module.exports = __webpack_public_path__ + "img/facebook.32a91e51.png";